"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCoinUsdPrice = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var MAPPING = {
    BNB: "binancecoin",
    BUSD: "busd",
};
var DEFAULT_PRICE = {
    BNB: 666,
};
function useCoinUsdPrice(symbol, intervalSec) {
    if (symbol === void 0) { symbol = "BNB"; }
    if (intervalSec === void 0) { intervalSec = 300; }
    var _a = (0, react_1.useState)("0"), price = _a[0], setPrice = _a[1];
    var coinId = MAPPING[symbol] || symbol;
    (0, react_1.useEffect)(function () {
        var update = function () {
            return axios_1.default
                .get("https://api.coingecko.com/api/v3/simple/price?ids=".concat(coinId, "&vs_currencies=usd"))
                .then(function (res) {
                setPrice(res.data[coinId]["usd"]);
            })
                .catch(function (e) {
                console.error("Failed to get price", coinId, e);
                if (DEFAULT_PRICE[symbol]) {
                    setPrice(DEFAULT_PRICE[symbol]);
                }
            });
        };
        if (typeof window !== "undefined") {
            update();
            var id_1 = setInterval(update, intervalSec * 1000);
            return function () {
                clearInterval(id_1);
            };
        }
    }, []);
    return price;
}
exports.useCoinUsdPrice = useCoinUsdPrice;
